import EventDTO from "./EventDTO";
import ZiftFileDTO from "./ZiftFileDTO";

export default class RequestFileSearchDTO {

  public page?: number;
  public size?: number;
  public labels?: Array<String>;
  public isProcessed?: Array<Boolean>;
  public isApproved?: Boolean;
  public isDeleted?: Boolean;
  public wasUpdated?: Boolean;
  public searchWord?: String;
  public lastUpdated?: Date;


 constructor(page: number, size: number, labels: Array<String>, isProcessed?: Array<Boolean>, isApproved?: boolean, isDeleted?: boolean, wasUpdated?: boolean, lastUpdated?: Date, searchWord?: String) {
    this.page = page;
    this.size = size;
    this.labels = labels;
    this.isApproved = isApproved;
    this.isProcessed = isProcessed;
    this.isDeleted = isDeleted;
    this.wasUpdated = wasUpdated;
    this.searchWord = searchWord;
    this.lastUpdated = lastUpdated;
  }

}
